export function isDevToolsEnabled(): boolean {
  return localStorage.getItem('dev-tools-on') === 'true';
}
